module.exports = __webpack_public_path__ + "static/media/FiltradoNaranja.1db93384.pdf";